import React, { useCallback } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import AssessmentActions from './questionnaire/AssessmentActions';
import { surveyStarted } from 'redux/checkIn/actions';
import { selectAnswers } from 'redux/checkIn/selectors';
import { sendClientAnalytics } from 'redux/sagas/clientAnalyticsSaga';
import { AuditEventAction, createClientAnalytics } from 'ClientAnalytics';

const PromptToStart = () => {
  const dispatch = useDispatch();
  const answers = useSelector(selectAnswers);
  const answersLength = Object.values(answers).reduce(
    (total, answer) => total + getTotalLength(answer),
    0,
  );
  const isAnswersEmpty = answersLength === 0;
  const { blurb, buttonText } = useCopy(isAnswersEmpty);

  const startSurvey = useCallback(() => {
    dispatch(surveyStarted());
    dispatch(
      sendClientAnalytics(
        createClientAnalytics(
          AuditEventAction.CHECKIN_START.category,
          AuditEventAction.CHECKIN_START.action,
        ),
      ),
    );
  }, [dispatch]);

  return (
    <AssessmentActions
      activeStep={answersLength}
      blurb={blurb}
      buttonText={buttonText}
      onClick={startSurvey}
    />
  );
};

export default PromptToStart;

const getTotalLength = (obj) => Object.values(obj).length;

const useCopy = (isAnswersEmpty) => {
  const intl = useIntl();
  const copy = defineMessages({
    selfAssessmentResume: {
      id: 'selfAssessment.resume',
      defaultMessage: 'Your progress was saved.',
      description: 'Resume self assessment survey',
    },
    selfAssessmentResumeButton: {
      id: 'selfAssessment.resume.button',
      defaultMessage: 'Resume Assessment',
      description: 'Self assessment resume button text',
    },
    selfAssessmentSurveyTime: {
      id: 'selfAssessment.surveytime',
      defaultMessage: 'The self assessment will take 6-10 minutes to complete.',
      description: 'Time estimated to complete self assessment survey',
    },
    selfAssessmentButton: {
      id: 'selfAssessment.button',
      defaultMessage: "Let's Go!",
      description: 'Self assessment button text',
    },
  });

  const blurb = isAnswersEmpty
    ? intl.formatMessage(copy.selfAssessmentSurveyTime)
    : intl.formatMessage(copy.selfAssessmentResume);
  const buttonText = isAnswersEmpty
    ? intl.formatMessage(copy.selfAssessmentButton)
    : intl.formatMessage(copy.selfAssessmentResumeButton);

  return { blurb, buttonText };
};
